'use client'
import React from 'react'
import dynamic from 'next/dynamic'

import { Page } from '../../../payload/payload-types'
import processSteps from '../../_utilities/data/sections/process-step.json'
import CounterSection from '../Section/Award'
import ContactSection from '../Section/Contact'
import DigitalService from '../Section/DigitalServices'
import IndustriesSection from '../Section/IndustriesSection'
import ProcessSection from '../Section/ProcessSection'

const HeroSlideshowSlider = dynamic(() => import('../Sliders/HeroSlideshow'), { ssr: false })
const Technology = dynamic(() => import('../Sliders/Technology'), { ssr: false })

const Home: React.FC = () => {
  return (
    <div>
      {/* Homepagexx section*/}
      <HeroSlideshowSlider />

      {/* digital services section*/}
      <DigitalService />

      {/* Developer section*/}
      <section className="mil-deep-bg mil-p-40-0">
        <div className="container">
          <div className="row ">
            <div className="col-xl-7">
              <h2 className="mil-mb-10 mil-h2">
                Our Development <span className="mil-accent">Process</span>
              </h2>
              <p className="mil-mb-30">
                We strictly follow Software Development Life Cycle in Our All Projects
              </p>
            </div>
          </div>
          <ProcessSection steps={processSteps} />
        </div>
      </section>

      {/* technology section*/}
      <section className="mil-p-40-0">
        <div className="container">
          <div className="mil-text-center mil-mb-40">
            <h2 className="mil-h2">
              <span className="mil-accent">Technologies</span>
            </h2>
          </div>
        </div>
      </section>

      <Technology />

      {/* Industries section*/}
      <section className="mil-p-40-0">
        <div className="container">
          <div className="mil-text-center mil-mb-40">
            <h2 className="mil-h2">
              <span className="mil-accent">Industries We Serve</span>
            </h2>
          </div>
        </div>
      </section>

      <IndustriesSection />
      {/* Serving section */}

      <CounterSection />
      {/* contact section */}
      <ContactSection />
    </div>
  )
}

export default Home
